import React, { useEffect, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { FormProvider, useForm } from 'react-hook-form';
import {
    Button,
    RadioControl,
    Col,
    FieldsetControl,
    ButtonGroup,
    InputControl,
    Row,
    SegmentLoader,
} from '@si-armes/dsfr-react';
import { useHistory } from 'react-router-dom';
import useToaster from 'hooks/useToaster';
import {
    FEATURE_APPEL_API_FFBT,
    FEATURE_APPEL_API_FFTIR,
    isFeatureActive,
} from 'components/FeatureFlipping/featureFlipping.func';
import {
    API_AJOUTER_PERSONA,
    API_RECUPERER_INFORMATIONS_PERSONNELLES,
    CONTEXT_API_AJOUTER_PERSONA,
    CONTEXT_API_RECUPERER_INFORMATIONS_PERSONNELLES,
} from '../../../../constants/apiUrls.constants';
import RoutesModifierInformationsCompte from '../modifier-informations-compte/routes';
import { getAPI, postAPI, reinitialiseAPI } from '../../../../store/apiReducer';
import usagerClientReducer from '../../../../store/usagerReducer';
import InputFiles from '../../../../components/Commun/Form/InputFiles';
import FileUploadeBack from '../../../../components/form/InputFiles/Model/FileUploadeBack';
import { getPatternHookFormValidation } from '../../../../utils/utils';
import { REGEXP_NUMERO_GUICHET_UNIQUE } from '../../../../constants/contraintes.constants';
import ModaleDeconnexion from '../../../../components/ModaleDeconnexion/ModaleDeconnexion';
import RoutesEcranGestion from '../gestion/routes';
import InputsLicencie from './components/InputsLicencie';
import {
    ROLE_CHASSEUR,
    ROLE_TIREUR_BALLTRAP,
    ROLE_TIREUR_SKI,
    ROLE_TIREUR_SPORTIF,
} from '../../../../utils/droitsEtRoles.constant';
import { getPath } from '../../../../utils/router';

const AjouterPersona = ({
    getApi,
    postApi,
    reinitialiseApi,
    isLoadingCompteUsager,
    dataCompteUsager,
    erreurAjouterPersonaCompte,
    messageAjouterPersonaCompte,
    isLoadingAjouterPersonaCompte,
    dataAjouterPersonaCompte,
}) => {
    const hookForm = useForm({
        mode: 'onChange',
    });
    const { formState, handleSubmit, register, reset, getValues, setValue, watch } = hookForm;
    const [isDataGenere, setDataGenere] = useState(false);
    const [profil, setProfil] = useState('');
    const [afficherFormTir, setAfficherFormTir] = useState(false);
    const [afficherFormBallTrap, setAfficherFormBallTrap] = useState(false);
    const [afficherFormSki, setAfficherFormSki] = useState(false);
    const [ouvrirModale, setOuvrirModale] = useState(false);
    const history = useHistory();
    const [licenceTirExist, setLicenceTirExist] = useState(false);
    const [isAncienLicencieTir, setIsAncienLicencieTir] = useState(false);
    const [licenceBallTrapExist, setLicenceBallTrapExist] = useState(false);
    const [isAncienLicencieBallTrap, setIsAncienLicencieBallTrap] = useState(false);
    const [licenceSkiExist, setLicenceSkiExist] = useState(false);
    const [isAncienLicencieSki, setIsAncienLicencieSki] = useState(false);
    const { triggerToaster, closeToaster } = useToaster();
    const { data: featureFlipping } = useSelector((state) => state.featureFlipping);
    const [licencesFichiersDuCompteUsager, setLicencesFichiersDuCompteUsager] = useState({});

    useEffect(() => {
        reinitialiseApi(CONTEXT_API_AJOUTER_PERSONA);
        reinitialiseApi(CONTEXT_API_RECUPERER_INFORMATIONS_PERSONNELLES);
        getApi(
            usagerClientReducer,
            API_RECUPERER_INFORMATIONS_PERSONNELLES,
            CONTEXT_API_RECUPERER_INFORMATIONS_PERSONNELLES,
        );

        return () => {
            reinitialiseApi(CONTEXT_API_RECUPERER_INFORMATIONS_PERSONNELLES);
        };
    }, []);

    const genererFichier = (file, name) => {
        const fichier = new FileUploadeBack({
            filename: file.filename,
            uuid: file.uuid,
        });
        setLicencesFichiersDuCompteUsager((prev) => ({
            ...prev,
            [name]: fichier,
        }));
        setValue(name, [fichier]);
    };

    const setLicenceEtFichier = (licence, numero, fichier) => {
        setValue(numero, licence?.numero);
        if (licence?.licenceFichier) {
            genererFichier(licence.licenceFichier, fichier);
        }
    };

    useEffect(() => {
        setDataGenere(false);

        if (isLoadingCompteUsager === false && dataCompteUsager) {
            const { licenceTir, licenceBallTrap, licenceSki } = dataCompteUsager.licences;

            if (licenceTir) {
                setLicenceTirExist(true);
                setIsAncienLicencieTir(licenceTir.isAncienLicencie);
                setLicenceEtFichier(licenceTir, 'numeroLicenceTir', 'licenceTirFichier');
            }

            if (licenceBallTrap) {
                setLicenceBallTrapExist(true);
                setIsAncienLicencieBallTrap(licenceBallTrap.isAncienLicencie);
                setLicenceEtFichier(
                    licenceBallTrap,
                    'numeroLicenceBallTrap',
                    'licenceBallTrapFichier',
                );
                setValue('numeroLicenceBallTrap', licenceBallTrap?.numero);
            }

            if (licenceSki) {
                setLicenceSkiExist(true);
                setIsAncienLicencieSki(licenceSki.isAncienLicencie);
                setLicenceEtFichier(licenceSki, 'numeroLicenceSki', 'licenceSkiFichier');
            }
        } else {
            reset({});
        }
        setDataGenere(true);
    }, [dataCompteUsager]);

    useEffect(() => {
        setValue('selectLicencieOrAncienLicencieTir', '');
        setValue('selectLicencieOrAncienLicencieBallTrap', '');
        setValue('selectLicencieOrAncienLicencieSki', '');
    }, []);

    useEffect(() => {
        if (watch('selectLicencieOrAncienLicencieTir')) {
            setAfficherFormTir(true);
        }
    }, [watch('selectLicencieOrAncienLicencieTir')]);

    useEffect(() => {
        if (watch('selectLicencieOrAncienLicencieBallTrap')) {
            setAfficherFormBallTrap(true);
        }
    }, [watch('selectLicencieOrAncienLicencieBallTrap')]);

    useEffect(() => {
        if (watch('selectLicencieOrAncienLicencieSki')) {
            setAfficherFormSki(true);
        }
    }, [watch('selectLicencieOrAncienLicencieSki')]);

    const redirectToEcranModifierInformationsCompte = () => {
        history.push(getPath(RoutesModifierInformationsCompte));
    };

    const formaterChampsNumeroGuichetUnique = (value) => {
        return value.replace(/\D/g, '');
    };

    const redirectToEcranGestion = () => {
        history.push(getPath(RoutesEcranGestion));
    };

    useEffect(() => {
        if (
            dataAjouterPersonaCompte &&
            isLoadingAjouterPersonaCompte === false &&
            erreurAjouterPersonaCompte === false
        ) {
            reinitialiseApi(CONTEXT_API_AJOUTER_PERSONA);
            if (dataAjouterPersonaCompte.changementDeRole) {
                setOuvrirModale(true);
            } else {
                redirectToEcranGestion();
            }
        }
    }, [
        erreurAjouterPersonaCompte,
        messageAjouterPersonaCompte,
        isLoadingAjouterPersonaCompte,
        dataAjouterPersonaCompte,
    ]);

    const shouldDisableButtonIfFilled = () => {
        if (dataCompteUsager) {
            const conditionsForTir =
                profil === ROLE_TIREUR_SPORTIF &&
                ((dataCompteUsager.licences?.licenceTir?.numero &&
                    dataCompteUsager.licences?.licenceTir?.numero !== '' &&
                    dataCompteUsager.licences?.licenceTir?.isAncienLicencie === false &&
                    watch('selectLicencieOrAncienLicencieTir') === 'isLicencie') ||
                    (dataCompteUsager.licences?.licenceTir?.isAncienLicencie === true &&
                        watch('selectLicencieOrAncienLicencieTir') === 'isAncienLicencie'));

            const conditionsForBallTrap =
                profil === ROLE_TIREUR_BALLTRAP &&
                ((dataCompteUsager.licences?.licenceBallTrap?.numero &&
                    dataCompteUsager.licences?.licenceBallTrap?.numero !== '' &&
                    dataCompteUsager.licences?.licenceBallTrap?.isAncienLicencie === false &&
                    watch('selectLicencieOrAncienLicencieBallTrap') === 'isLicencie') ||
                    (dataCompteUsager.licences?.licenceBallTrap?.isAncienLicencie === true &&
                        watch('selectLicencieOrAncienLicencieBallTrap') === 'isAncienLicencie'));

            const conditionsForSki =
                profil === ROLE_TIREUR_SKI &&
                ((dataCompteUsager.licences?.licenceSki?.numero &&
                    dataCompteUsager.licences?.licenceSki?.numero !== '' &&
                    dataCompteUsager.licences?.licenceSki?.isAncienLicencie === false &&
                    watch('selectLicencieOrAncienLicencieSki') === 'isLicencie') ||
                    (dataCompteUsager.licences?.licenceSki?.isAncienLicencie === true &&
                        watch('selectLicencieOrAncienLicencieSki') === 'isAncienLicencie'));

            return conditionsForTir || conditionsForBallTrap || conditionsForSki;
        }

        return false;
    };

    const hasFormValid = () => {
        if (dataCompteUsager) {
            const validPermisChasser =
                watch('numeroPermisChasser') &&
                watch('permisChasserFichier') &&
                !!watch('permisChasserFichier')[0];

            const validPermisChasserValidation =
                !watch('numeroGuichetUnique') ||
                (watch('numeroGuichetUnique') &&
                    watch('validationPermisChasserFichier') &&
                    !!watch('validationPermisChasserFichier')[0]);

            const validLicenceTir =
                (watch('numeroLicenceTir') &&
                    watch('numeroLicenceTir') !== '' &&
                    watch('selectLicencieOrAncienLicencieTir') === 'isLicencie') ||
                watch('selectLicencieOrAncienLicencieTir') === 'isAncienLicencie';

            const validLicenceBallTrap =
                (watch('numeroLicenceBallTrap') &&
                    (watch('licenceBallTrapFichier') || licencesFichiersDuCompteUsager) &&
                    watch('selectLicencieOrAncienLicencieBallTrap') === 'isLicencie' &&
                    watch('numeroLicenceBallTrap') !== '') ||
                watch('selectLicencieOrAncienLicencieBallTrap') === 'isAncienLicencie';

            const validLicenceSki =
                (watch('numeroLicenceSki') &&
                    (watch('licenceSkiFichier') || licencesFichiersDuCompteUsager) &&
                    watch('selectLicencieOrAncienLicencieSki') === 'isLicencie' &&
                    watch('numeroLicenceSki') !== '') ||
                watch('selectLicencieOrAncienLicencieSki') === 'isAncienLicencie';

            return (
                (validPermisChasser && validPermisChasserValidation) ||
                validLicenceTir ||
                validLicenceBallTrap ||
                validLicenceSki
            );
        }
        return false;
    };

    const formaterModification = async (dataForm) => {
        return {
            numeroPermisChasser: dataForm.numeroPermisChasser ?? null,
            numeroGuichetUnique: dataForm.numeroGuichetUnique ?? null,
            permisChasserFichier:
                dataForm.permisChasserFichier && dataForm.permisChasserFichier.length
                    ? await dataForm.permisChasserFichier[0].getFileToSend()
                    : null,
            licenceTir: dataForm.selectLicencieOrAncienLicencieTir
                ? {
                      isAncienLicencie:
                          dataForm.selectLicencieOrAncienLicencieTir &&
                          dataForm.selectLicencieOrAncienLicencieTir === 'isAncienLicencie',
                      numero: dataForm.numeroLicenceTir ?? null,
                  }
                : null,
            licenceTirFichier:
                dataForm.licenceTirFichier && dataForm.licenceTirFichier.length
                    ? await dataForm.licenceTirFichier[0].getFileToSend()
                    : null,
            guichetUniqueFichier:
                dataForm.validationPermisChasserFichier &&
                dataForm.validationPermisChasserFichier.length
                    ? await dataForm.validationPermisChasserFichier[0].getFileToSend()
                    : null,
            licenceBallTrapFichier:
                dataForm.licenceBallTrapFichier && dataForm.licenceBallTrapFichier.length
                    ? await dataForm.licenceBallTrapFichier[0].getFileToSend()
                    : null,
            licenceBallTrap: dataForm.selectLicencieOrAncienLicencieBallTrap
                ? {
                      isAncienLicencie:
                          dataForm.selectLicencieOrAncienLicencieBallTrap &&
                          dataForm.selectLicencieOrAncienLicencieBallTrap === 'isAncienLicencie',
                      numero: dataForm.numeroLicenceBallTrap ?? null,
                  }
                : null,
            licenceSkiFichier:
                dataForm.licenceSkiFichier && dataForm.licenceSkiFichier.length
                    ? await dataForm.licenceSkiFichier[0].getFileToSend()
                    : null,
            licenceSki: dataForm.selectLicencieOrAncienLicencieSki
                ? {
                      isAncienLicencie:
                          dataForm.selectLicencieOrAncienLicencieSki &&
                          dataForm.selectLicencieOrAncienLicencieSki === 'isAncienLicencie',
                      numero: dataForm.numeroLicenceSki ?? null,
                  }
                : null,
        };
    };

    const determineLicencieValue = (licence) => {
        if (!licence) return null;
        return licence.isAncienLicencie ? 'isAncienLicencie' : 'isLicencie';
    };

    const postInformations = async (dataForm) => {
        // Formatage des données avant la validation du toaster
        const dataFormat = await formaterModification(dataForm);

        reinitialiseApi(CONTEXT_API_AJOUTER_PERSONA);

        // Appel à l'API avec les données formatées
        await postApi(
            usagerClientReducer,
            API_AJOUTER_PERSONA,
            dataFormat,
            CONTEXT_API_AJOUTER_PERSONA,
        );
    };

    useEffect(() => {
        if (isLoadingAjouterPersonaCompte) {
            // Vérification des licences et génération du message approprié
            if (
                (isFeatureActive(featureFlipping, FEATURE_APPEL_API_FFTIR) &&
                    getValues('numeroLicenceTir') &&
                    getValues('selectLicencieOrAncienLicencieTir') === 'isLicencie') ||
                (isFeatureActive(featureFlipping, FEATURE_APPEL_API_FFBT) &&
                    getValues('numeroLicenceBallTrap') &&
                    getValues('selectLicencieOrAncienLicencieBallTrap') === 'isLicencie')
            ) {
                triggerToaster();
            }
        } else {
            closeToaster();
        }
    }, [isLoadingAjouterPersonaCompte, featureFlipping]);

    const onSubmit = async (dataForm) => {
        if (dataForm && hasFormValid()) {
            // Appel à la fonction intermédiaire qui formate et poste les données
            await postInformations(dataForm);
        }
    };

    return (
        <SegmentLoader isLoading={isLoadingCompteUsager || !isDataGenere}>
            {ouvrirModale && <ModaleDeconnexion />}

            {erreurAjouterPersonaCompte && messageAjouterPersonaCompte && (
                <Row>
                    <Col col={12}>
                        <p className="fr-error">{messageAjouterPersonaCompte}</p>
                    </Col>
                </Row>
            )}

            <Row>
                <Col col={12}>
                    <h1>Ajout de profil</h1>
                </Col>
            </Row>
            <Row>
                <Col col={12}>
                    <p>Il est possible d'ajouter un seul profil à la fois</p>
                </Col>
            </Row>
            <FormProvider {...hookForm}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <Row>
                        <Col lg={4} sm={12} md={12}>
                            <ButtonGroup>
                                <Button
                                    name="tireurSportif"
                                    type="button"
                                    variant={
                                        profil === ROLE_TIREUR_SPORTIF ? 'primary' : 'secondary'
                                    }
                                    aria-label="Afficher le formulaire pour un tireur sportif"
                                    onClick={() => {
                                        setProfil(ROLE_TIREUR_SPORTIF);
                                        setAfficherFormBallTrap(false);
                                        setAfficherFormSki(false);
                                        reset({
                                            numeroLicenceTir:
                                                dataCompteUsager?.licences?.licenceTir?.numero,
                                            selectLicencieOrAncienLicencieTir:
                                                determineLicencieValue(
                                                    dataCompteUsager?.licences?.licenceTir,
                                                ),
                                        });
                                    }}
                                >
                                    Tireur sportif
                                </Button>
                                <Button
                                    name="ballTrap"
                                    type="button"
                                    aria-label="Afficher le formulaire pour un pratiquant de Ball-trap"
                                    variant={
                                        profil === ROLE_TIREUR_BALLTRAP ? 'primary' : 'secondary'
                                    }
                                    onClick={() => {
                                        setProfil(ROLE_TIREUR_BALLTRAP);
                                        setAfficherFormTir(false);
                                        setAfficherFormSki(false);
                                        reset({
                                            numeroLicenceBallTrap:
                                                dataCompteUsager?.licences?.licenceBallTrap?.numero,
                                            selectLicencieOrAncienLicencieBallTrap:
                                                determineLicencieValue(
                                                    dataCompteUsager?.licences?.licenceBallTrap,
                                                ),
                                        });
                                    }}
                                >
                                    Ball-Trap
                                </Button>
                                <Button
                                    name="biathlon"
                                    type="button"
                                    aria-label="Afficher le formulaire pour un pratiquant de Biathlon"
                                    variant={profil === ROLE_TIREUR_SKI ? 'primary' : 'secondary'}
                                    onClick={() => {
                                        setProfil(ROLE_TIREUR_SKI);
                                        setAfficherFormTir(false);
                                        setAfficherFormBallTrap(false);
                                        reset({
                                            numeroLicenceSki:
                                                dataCompteUsager?.licences?.licenceSki?.numero,
                                            selectLicencieOrAncienLicencieSki:
                                                determineLicencieValue(
                                                    dataCompteUsager?.licences?.licenceSki,
                                                ),
                                        });
                                    }}
                                >
                                    Biathlon
                                </Button>
                                <Button
                                    name="heritier"
                                    type="button"
                                    aria-label="Afficher le formulaire pour un chasseur"
                                    variant={profil === ROLE_CHASSEUR ? 'primary' : 'secondary'}
                                    onClick={() => {
                                        setProfil(ROLE_CHASSEUR);
                                        setAfficherFormTir(false);
                                        setAfficherFormBallTrap(false);
                                        setAfficherFormSki(false);
                                        reset({
                                            numeroLicenceBallTrap:
                                                dataCompteUsager?.licences?.licenceBallTrap?.numero,
                                            numeroLicenceTir:
                                                dataCompteUsager?.licences?.licenceTir?.numero,
                                            numeroLicenceSki:
                                                dataCompteUsager?.licences?.licenceSki?.numero,
                                        });
                                    }}
                                    disabled={dataCompteUsager?.licences.permisChasser}
                                >
                                    Chasseur
                                </Button>
                            </ButtonGroup>
                        </Col>
                        <Col lg={8} sm={12} md={12}>
                            {profil === ROLE_TIREUR_SPORTIF && (
                                <Row gutters verticalAlign="center" horizontalAlign="center">
                                    <Col lg={10} sm={12} md={12}>
                                        <FieldsetControl
                                            id="tireur-sportif-fieldset"
                                            legend="Tireur Sportif"
                                        >
                                            <RadioControl
                                                id="selectLicencieOrAncienLicencieTir-isLicencie"
                                                label="Licencié"
                                                value="isLicencie"
                                                aria-label="Je suis actuellement licencié"
                                                {...register('selectLicencieOrAncienLicencieTir')}
                                            />
                                            <RadioControl
                                                id="selectLicencieOrAncienLicencieTir-isAncienLicencie"
                                                label="Ancien licencié"
                                                aria-label="Je suis un ancien licencié"
                                                value="isAncienLicencie"
                                                {...register('selectLicencieOrAncienLicencieTir')}
                                            />
                                        </FieldsetControl>
                                        {afficherFormTir === true && (
                                            <InputsLicencie
                                                selectLicencieOrAncienLicencie={watch(
                                                    'selectLicencieOrAncienLicencieTir',
                                                )}
                                                licenceExist={licenceTirExist}
                                                isAncienLicencie={isAncienLicencieTir}
                                                numeroLicence="numeroLicenceTir"
                                                labelInputMi="Numéro de licence de Tir"
                                                licenceFichierName={
                                                    isFeatureActive(
                                                        featureFlipping,
                                                        FEATURE_APPEL_API_FFTIR,
                                                    )
                                                        ? undefined
                                                        : 'licenceTirFichier'
                                                }
                                                register={register}
                                                licence={dataCompteUsager?.licences?.licenceTir}
                                                fileUploaded={
                                                    licencesFichiersDuCompteUsager.licenceTirFichier
                                                }
                                                labelTelechargement="Télécharger la licence de Tir"
                                            />
                                        )}
                                    </Col>
                                </Row>
                            )}

                            {profil === ROLE_TIREUR_BALLTRAP && (
                                <Row gutters verticalAlign="center" horizontalAlign="center">
                                    <Col lg={10} sm={12} md={12}>
                                        <FieldsetControl id="ball-trap-fieldset" legend="Ball-Trap">
                                            <RadioControl
                                                id="selectLicencieOrAncienLicencieBallTrap-isLicencie"
                                                label="Licencié"
                                                value="isLicencie"
                                                aria-label="Je suis actuellement licencié"
                                                {...register(
                                                    'selectLicencieOrAncienLicencieBallTrap',
                                                )}
                                            />
                                            <RadioControl
                                                id="selectLicencieOrAncienLicencieBallTrap-isAncienLicencie"
                                                label="Ancien licencié"
                                                value="isAncienLicencie"
                                                aria-label="Je suis un ancien licencié"
                                                {...register(
                                                    'selectLicencieOrAncienLicencieBallTrap',
                                                )}
                                            />
                                        </FieldsetControl>
                                        {afficherFormBallTrap === true && (
                                            <InputsLicencie
                                                selectLicencieOrAncienLicencie={watch(
                                                    'selectLicencieOrAncienLicencieBallTrap',
                                                )}
                                                licenceExist={licenceBallTrapExist}
                                                isAncienLicencie={isAncienLicencieBallTrap}
                                                numeroLicence="numeroLicenceBallTrap"
                                                labelInputMi="Numéro de licence de Ball-Trap"
                                                licenceFichierName="licenceBallTrapFichier"
                                                register={register}
                                                licence={
                                                    dataCompteUsager?.licences?.licenceBallTrap
                                                }
                                                fileUploaded={
                                                    licencesFichiersDuCompteUsager.licenceBallTrapFichier
                                                }
                                                labelTelechargement="Télécharger la licence de Ball-Trap"
                                            />
                                        )}
                                    </Col>
                                </Row>
                            )}

                            {profil === ROLE_TIREUR_SKI && (
                                <Row gutters verticalAlign="center" horizontalAlign="center">
                                    <Col lg={10} sm={12} md={12}>
                                        <FieldsetControl id="biathlon-fieldset" legend="Biathlon">
                                            <RadioControl
                                                id="selectLicencieOrAncienLicencieSki-isLicencie"
                                                label="Licencié"
                                                value="isLicencie"
                                                aria-label="Je suis actuellement licencié"
                                                {...register('selectLicencieOrAncienLicencieSki')}
                                            />
                                            <RadioControl
                                                id="selectLicencieOrAncienLicencieSki-isAncienLicencie"
                                                label="Ancien licencié"
                                                value="isAncienLicencie"
                                                aria-label="Je suis un ancien licencié"
                                                {...register('selectLicencieOrAncienLicencieSki')}
                                            />
                                        </FieldsetControl>
                                        {afficherFormSki === true && (
                                            <InputsLicencie
                                                selectLicencieOrAncienLicencie={watch(
                                                    'selectLicencieOrAncienLicencieSki',
                                                )}
                                                licenceExist={licenceSkiExist}
                                                isAncienLicencie={isAncienLicencieSki}
                                                numeroLicence="numeroLicenceSki"
                                                labelInputMi="Numéro de licence de Ski"
                                                licenceFichierName="licenceSkiFichier"
                                                register={register}
                                                licence={dataCompteUsager.licences?.licenceSki}
                                                fileUploaded={
                                                    licencesFichiersDuCompteUsager.licenceSkiFichier
                                                }
                                                labelTelechargement="Télécharger la licence de Ski"
                                            />
                                        )}
                                    </Col>
                                </Row>
                            )}

                            {profil === ROLE_CHASSEUR && (
                                <Row horizontalAlign="center">
                                    <Col lg={10} sm={12} md={12}>
                                        <FieldsetControl id="chasseur-fieldset" legend="Chasseur">
                                            <InputControl
                                                id="numeroPermisChasser"
                                                name="numeroPermisChasser"
                                                label="Numéro de permis de chasser"
                                                {...register('numeroPermisChasser')}
                                                required
                                            />
                                            <InputFiles
                                                name="permisChasserFichier"
                                                label="Ajouter mon permis de chasser"
                                                disabled={!watch('numeroPermisChasser')}
                                                required
                                            />
                                            <InputControl
                                                id="numeroGuichetUnique"
                                                name="numeroGuichetUnique"
                                                label="Numéro de guichet unique de votre validation en cours"
                                                {...register('numeroGuichetUnique', {
                                                    pattern: getPatternHookFormValidation(
                                                        REGEXP_NUMERO_GUICHET_UNIQUE,
                                                        'numero guichet unique',
                                                        'Veuillez renseigner a minima 14 caractères',
                                                    ),
                                                })}
                                                state={
                                                    formState.errors?.numeroGuichetUnique
                                                        ? 'error'
                                                        : null
                                                }
                                                message={
                                                    formState.errors?.numeroGuichetUnique?.message
                                                }
                                                maskFonction={formaterChampsNumeroGuichetUnique}
                                                minLength="14"
                                                disabled={!watch('numeroPermisChasser')}
                                            />
                                            <InputFiles
                                                name="validationPermisChasserFichier"
                                                label="Ajouter ma validation de permis de chasser"
                                                required={watch('numeroGuichetUnique')}
                                                disabled={!watch('numeroGuichetUnique')}
                                            />
                                        </FieldsetControl>
                                    </Col>
                                </Row>
                            )}
                        </Col>
                    </Row>

                    <Row className="margin-top-lg">
                        <Col col={12}>
                            <ButtonGroup align="right" inline>
                                <Button
                                    name="retour"
                                    variant="secondary"
                                    onClick={redirectToEcranModifierInformationsCompte}
                                >
                                    Retour
                                </Button>
                                <Button
                                    name="valider"
                                    variant="primary"
                                    type="submit"
                                    disabled={!hasFormValid() || shouldDisableButtonIfFilled()}
                                    isLoading={isLoadingAjouterPersonaCompte}
                                >
                                    Valider l'ajout de profil
                                </Button>
                            </ButtonGroup>
                        </Col>
                    </Row>
                </form>
            </FormProvider>
        </SegmentLoader>
    );
};

AjouterPersona.propTypes = {
    getApi: PropTypes.func.isRequired,
    postApi: PropTypes.func.isRequired,
    reinitialiseApi: PropTypes.func.isRequired,
    isLoadingCompteUsager: PropTypes.bool,
    dataCompteUsager: PropTypes.shape({
        compte: PropTypes.shape({
            username: PropTypes.string.isRequired,
        }).isRequired,
        licences: PropTypes.shape({
            permisChasser: PropTypes.shape({
                numero: PropTypes.string.isRequired,
                numeroGuichetUnique: PropTypes.string,
                permisChasserFichier: PropTypes.shape({
                    uuid: PropTypes.string.isRequired,
                    filename: PropTypes.string.isRequired,
                }).isRequired,
                validationPermisChasserFichier: PropTypes.shape({
                    uuid: PropTypes.string.isRequired,
                    filename: PropTypes.string.isRequired,
                }),
            }),
            licenceTir: PropTypes.shape({
                numero: PropTypes.string.isRequired,
                isAncienLicencie: PropTypes.bool.isRequired,
            }),
            licenceBallTrap: PropTypes.shape({
                numero: PropTypes.string,
                licenceFichier: PropTypes.oneOfType([
                    PropTypes.shape({
                        uuid: PropTypes.string,
                        filename: PropTypes.string,
                    }),
                    PropTypes.oneOf([null]),
                ]),
                isAncienLicencie: PropTypes.bool.isRequired,
            }),
            licenceSki: PropTypes.shape({
                numero: PropTypes.string,
                licenceFichier: PropTypes.oneOfType([
                    PropTypes.shape({
                        uuid: PropTypes.string,
                        filename: PropTypes.string,
                    }),
                    PropTypes.oneOf([null]),
                ]),
                isAncienLicencie: PropTypes.bool.isRequired,
            }),
        }),
        personnePhysique: PropTypes.shape({
            numeroSia: PropTypes.string.isRequired,
            certificatMedicalARS: PropTypes.shape({
                uuid: PropTypes.string.isRequired,
                filename: PropTypes.string.isRequired,
            }),
        }).isRequired,
        typeCompte: PropTypes.array.isRequired,
    }),
    erreurAjouterPersonaCompte: PropTypes.any,
    messageAjouterPersonaCompte: PropTypes.any,
    isLoadingAjouterPersonaCompte: PropTypes.bool,
    dataAjouterPersonaCompte: PropTypes.shape({
        changementDeRole: PropTypes.bool.isRequired,
    }),
};

export default connect(
    (state) => {
        const { isLoading: isLoadingCompteUsager, data: dataCompteUsager } =
            state.monCompte.recupererInformationsPersonnelles;
        const {
            isLoading: isLoadingAjouterPersonaCompte,
            erreur: erreurAjouterPersonaCompte,
            message: messageAjouterPersonaCompte,
            data: dataAjouterPersonaCompte,
        } = state.monCompte.ajouterPersona;
        return {
            isLoadingCompteUsager,
            dataCompteUsager,
            erreurAjouterPersonaCompte,
            messageAjouterPersonaCompte,
            isLoadingAjouterPersonaCompte,
            dataAjouterPersonaCompte,
        };
    },
    {
        getApi: getAPI,
        postApi: postAPI,
        reinitialiseApi: reinitialiseAPI,
    },
)(AjouterPersona);
